export enum EmailTemplateRecipientType {
BCC,
To,
CC,
}
